
function getMapDirectionsUrl({ lat, lon }: { lat: number; lon: number }) {
  return `https://www.google.com/maps/dir//${lat.toString().substr(0, 13)},${lon.toString().substr(0, 13)}`;
}

export const GoogleMapsCommonUtils = {
  getMapDirectionsUrl,
};
